<ng-container
  [ngTemplateOutlet]="tpl"
  [ngTemplateOutletContext]="{ $implicit: availableOptions$ | async }" />


<ng-template #tpl let-availableOptions>
  <mat-form-field class="w-full">
    <mat-select
      [(value)]="_selectedProfileId"
      placeholder="Use existing profile"
      [disabled]="!availableOptions || disabled"
      >
      @if (!availableOptions) {
        <mat-select-trigger>
          Loading profiles...
        </mat-select-trigger>
      }

      <mat-option [value]="CustomProfileIndicator">
        Custom
      </mat-option>

      @for (profile of availableOptions; track profile) {
        <mat-option
          [value]="profile._id"
          >
          {{ profile.displayName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-template>
